import { render, staticRenderFns } from "./andrea.vue?vue&type=template&id=61459b1d"
import script from "./andrea.vue?vue&type=script&lang=js"
export * from "./andrea.vue?vue&type=script&lang=js"
import style0 from "./andrea.vue?vue&type=style&index=0&id=61459b1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports